import Vue from 'vue'

/**
 * Estado global reactivo para controlar si algún AccessibleElSelect
 * tiene el dropdown abierto. AccessibleElSelect lo escribe internamente;
 * cualquier componente puede importarlo para leerlo (p.ej. en close-on-click-modal).
 */
export const dropdownState = Vue.observable({
  isAnyDropdownOpen: false,
})
